export default __webpack_public_path__ + "static/media/neutralizer.6fbffc62.png";